<app-header [title]="'Passports'" [notificationsCount]="commentsNotification.unreadCount()" [showSearchIcon]="true" [showFilterIcon]="true" [showDesktopFilters]="true" [filterDefinitions]="filters" (refresh)="onRefresh()"></app-header>
<div class="gatehouse-page" [style.paddingTop.px]="(ui.searchOpen() || ui.filtersOpen()) ? 0 : 50">
  
  <!-- Mobile View -->
  <div class="mobile-view">
    <app-scheduler-status-tabs 
      [allCount]="allCount"
      [loadCount]="loadCount"
      [shuntingCount]="shuntingCount"
      [transloadingCount]="transloadingCount"
      [transferredCount]="transferredCount"
      [showTransferredTab]="false"></app-scheduler-status-tabs>
    
    <app-no-passports *ngIf="visibleRecords.length === 0"></app-no-passports>
    
    <ng-container *ngFor="let rec of visibleRecords; trackBy: trackById; let i = index">
      <app-gatehouse-passport-cell [recordId]="rec.id"
        [loadNumber]="detailsStore.get(rec.id)?.loadNumber || rec.id"
        [scheduledText]="((detailsStore.get(rec.id)?.dueDateTime) | dateWithOrdinal:'EEE, d MMM y, HH:mm') || 'No scheduled date'"
        [vendorName]="detailsStore.get(rec.id)?.vendorName || ''"
        [bulkerNumber]="detailsStore.get(rec.id)?.bulkerMain || detailsStore.get(rec.id)?.bulkerNumber || ''"
        [haulier]="detailsStore.get(rec.id)?.haulier || ''"
        [origin]="detailsStore.get(rec.id)?.origin || ''"
        [destination]="detailsStore.get(rec.id)?.destinationWeighbridge || detailsStore.get(rec.id)?.destination || ''"
        [apn]="detailsStore.get(rec.id)?.apn || ''"
        [apnName]="detailsStore.get(rec.id)?.apnName || ''"
        [vendorNumber]="detailsStore.get(rec.id)?.vendorNumber || ''"
        [status]="rec.status"
        [styleState]="getStyleState(rec.id)"
        [class.expanded]="ui.expandedRecordId() === rec.id"></app-gatehouse-passport-cell>
      <div class="passport-cell-spacer"></div>
    </ng-container>
  </div>

  <!-- Desktop View -->
  <app-passports-desktop-table
    [sortedPaginatedRecords]="sortedPaginatedRecords"
    [visibleRecordsLength]="visibleRecords.length"
    [selectedTab]="ui.schedulerTabSelected()"
    [allCount]="allCount"
    [loadCount]="loadCount"
    [shuntingCount]="shuntingCount"
    [transloadingCount]="transloadingCount"
    [receivingCount]="receivingCount"
    [transferredCount]="transferredCount"
    [itemsPerPage]="itemsPerPage"
    [currentPage]="currentPage"
    [totalPages]="totalPages"
    [rowsDropdownOpen]="rowsDropdownOpen"
    [detailsStore]="detailsStore"
    (tabSelect)="onTabSelect($event)"
    (sort)="onSort($event)"
    (pageChange)="onPageChange($event)"
    (toggleRowsDropdown)="toggleRowsDropdown($event)"
    (setItemsPerPage)="setItemsPerPage($event)"
    (refresh)="onRefresh()"
    (openPassportDetails)="openPassportDetails($event)"
    (openHistory)="openHistory($event)"
    (openComments)="openComments($event)">
  </app-passports-desktop-table>
</div>

<app-loading-spinner [isLoading]="isLoading()" text="Loading passports…"></app-loading-spinner>

<app-navbar [items]="navbarItems" [selectedId]="'home'" (selectedIdChange)="onNavChange($event)"></app-navbar>